/* global document */
/* eslint-disable */
(function () {
  'use strict';

  class PlanosSolucoesCtrl {
    constructor(Authenticator, FeatureOuService, $state, $window, ServiceVfiltro, FactoryVfiltro) {
      this.auth = Authenticator;
      this.FeatureOuService = FeatureOuService;
      this.window = $window;
      this.state = $state;
      this.shouldRedirectToUnauthorizedNAPage = false;
      ServiceVfiltro.init(FactoryVfiltro.get([]))
        .then(() => {
          this.init();
        });
    }

    init() {
      this.auth.getUser().then((user) => {
        this.window.localStorage.removeItem(`vfiltro-${user.id}`);
        const contratacaoPlanos = angular.element('vfwc-contratacao-planos')[0];
        if (contratacaoPlanos) {
          contratacaoPlanos.solucaoIds = user.plain().solucoes.map(solucao => solucao.solucaoId);
          contratacaoPlanos.uoId = user.plain().uo.id;
        }
        this.getEventsConfig(user.plain().uo.id);
      });
    }

    getEventsConfig(userUoId) {
      this.FeatureOuService.getEventsConfig(userUoId).then((eventNaConfig) => {
        this.shouldRedirectToUnauthorizedNAPage = eventNaConfig;
        if (this.shouldRedirectToUnauthorizedNAPage) {
          this.state.go('root.unauthorized');
        } 
      }).catch((error) => {
        console.error('Error loading featureOu config: ', error);
      });
    }
  }

  PlanosSolucoesCtrl.$inject = ['Authenticator', 'FeatureOuService', '$state', '$window', 'ServiceVfiltro', 'FactoryVfiltro'];

  angular
    .module('planosSolucoesModule', [
      'ui.router',
      'v3gAuthenticatorModule',
      'ServiceVfiltroModule',
      'FactoryVfiltroModule'
    ])
    .controller('PlanosSolucoesCtrl', PlanosSolucoesCtrl);
}());